/** @format */

import React from 'react';
import { css } from '@emotion/core';
import { FadeLoader } from 'react-spinners';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Requests from '../../../api/requests';
import classNames from 'classnames';
import ButtonPrimary from '../../components/buttons/button-primary';
import ButtonSecondary from '../../components/buttons/button-secondary';
import Modal from '../../components/modal/modal';
import PopupOneButton from '../../components/popup/popup-one-button';
import { saveAdmin } from '../../../store/actions/user-actions';
import { selectKey } from '../../../utilities/helper';
import SessionStorage from '../../../api/session-storage';
import './terms-and-conditions.scss';
import { cancelSpeech } from '../../../utilities/helper';

const mapStateToProps = state => ({
  ...state,
});

const mapDispatchToProps = dispatch => {
  return bindActionCreators({ saveAdmin }, dispatch);
};
let timeoutID;
let msg = null;
class TermsAndConditions extends React.Component {
  constructor() {
    super();
    this.state = {
      modalIsOpen: false,
      termsAgreed: false,
      termsScrollPosition: 0,
      isFullyRead: false,
      scrollEnd: false,
      size: Math.round(window.innerHeight * 0.63),
      terms: '',
      index: 0,
      modalIndex: 0,
      isLoading: true,
      hasInvalidParams: false,
      hasInvalidAuthParams: false,
      hasContent: false,
      isRead: false,
      ariaHidden: true,
    };
  }

  componentDidMount = async () => {
    await cancelSpeech();
    window.addEventListener('keydown', this.keySelect);
    if (
      this.props.userStore.hasUserLoggedOut ||
      !this.props.userStore.admin ||
      !this.props.userStore.admin.admin_id
    ) {
      this.setState({ hasInvalidAuthParams: true });
    } else {
      if (this.props.userStore.admin.ts_and_cs_ind) {
        this.props.history.push('/test-launcher');
      } else {
        const admin = {
          admin_id: this.props.userStore.admin.admin_id,
          token: this.props.userStore.admin.token,
        };
        const { ok, json: body, status } = await Requests.getTerms(admin);

        if (ok) {
          if (status === 200) {
            this.setState({
              terms: body.ts_and_cs,
              isLoading: false,
              hasContent: true,
            });
          }
          const elem = document.getElementById('terms-container');
          if (elem.scrollHeight < this.state.size) {
            this.setState({ isFullyRead: true });
          }
          elem.addEventListener('scroll', () => this.setScrollPosition(elem));
          window.addEventListener('resize', this.setSize);
        } else {
          if (status === 400 || status === 403) {
            this.setState({ hasInvalidParams: true });
          }
        }

        setTimeout(() => {
          if (this.state.isFullyRead) {
            document.getElementById('agree-terms').focus();
          }
        }, 50);
        setTimeout(() => {
          this.scrollToTop();
        }, 100);
      }
      setTimeout(() => {
        if (document.getElementById('agree-terms')) {
          document
            .getElementById('agree-terms')
            .setAttribute('aria-hidden', 'false');
          this.setState({ ariaHidden: false });
        }
      }, 3000);
    }
    timeoutID = setTimeout(() => {
      document
        .getElementById('agree-terms')
        .setAttribute('aria-hidden', 'false');
      this.setState({ ariaHidden: false });
    }, 3000);
  };

  async componentWillUnmount() {
    if (window.speechSynthesis.speaking || window.speechSynthesis.paused) {
      await cancelSpeech();
      msg = null;
    }
    clearTimeout(timeoutID);
    timeoutID = 0;
    window.removeEventListener('keydown', this.keySelect);
  }

  async componentDidUpdate(prevProps, prevState) {
    if (
      prevState.isFullyRead === false &&
      this.state.isFullyRead === true &&
      this.state.termsAgreed === true
    ) {
      document.getElementById('button1').focus();
      if (window.speechSynthesis.speaking || window.speechSynthesis.paused) {
        await cancelSpeech();
        msg = null;
      }
    }
    if (prevState.isFullyRead === false && this.state.isFullyRead) {
      setTimeout(() => {
        document.getElementById('agree-terms').focus();
      }, 100);
    }
  }

  setSize = () => {
    this.setState({ size: Math.round(window.innerHeight * 0.63) });
  };

  setScrollPosition = elem => {
    this.setState({ termsScrollPosition: elem.scrollTop });
    if (
      elem.scrollTop + this.state.size <= elem.scrollHeight + 2 &&
      elem.scrollHeight - 2 <= elem.scrollTop + this.state.size
    ) {
      this.setState({ isFullyRead: true });
      this.setState({ scrollEnd: true });
    } else {
      this.setState({ isFullyRead: false });
      this.setState({ scrollEnd: true });
    }
  };

  scrollDown = () => {
    const element = document.getElementById('terms-container');
    element.scrollTop = this.state.termsScrollPosition + (this.state.size - 90);
  };

  scrollToBottom = () => {
    const element = document.getElementById('terms-container');
    element.scrollTop = element.scrollHeight;
  };

  scrollToTop = () => {
    const element = document.getElementById('terms-container');
    element.scrollTop = 0;
  };

  agreeTerms = () => {
    this.setState({
      termsAgreed: !this.state.termsAgreed,
    });
    if (!this.state.termsAgreed) {
      setTimeout(() => {
        if (document.getElementById('button1')) {
          document.getElementById('button1').focus();
        }
      }, 300);
    } else {
      document.getElementById('agree-terms').focus();
    }
  };

  onKeyPressAgree = event => {
    if (event.key === 'Enter') {
      this.agreeTerms();
    }
  };

  goNext = async () => {
    if (window.speechSynthesis.speaking || window.speechSynthesis.paused) {
      await cancelSpeech();
      msg = null;
    }
    const { saveAdmin } = this.props;
    const admin = {
      ...this.props.userStore.admin,
      ts_and_cs_ind: true,
    };
    const user = {
      admin_id: this.props.userStore.admin.admin_id,
      reg_id: this.props.userStore.admin.reg_id,
      token: this.props.userStore.admin.token,
    };
    const { ok, status } = await Requests.putTerms(user);

    if (ok) {
      if (status === 204) {
        saveAdmin(admin);
        this.props.history.push('/test-launcher');
      }
    } else {
      if (status === 400 || status === 403) {
        this.setState({ hasInvalidParams: true });
      }
      if (status === 500) {
        this.setState({ hasError: true });
      }
    }
  };

  getNavigationKeys = () => {
    let ids;
    const button = !this.state.isRead ? 'button-primary' : 'button-secondary';
    const termsSelectableAgreed = this.state.isRead
      ? ['agree-terms', button, 'button1', 'logout', 'terms-text']
      : ['agree-terms', button, 'button1', 'logout'];
    const termsSelectableDisagreed = this.state.isRead
      ? ['agree-terms', button, 'logout', 'terms-text']
      : ['agree-terms', button, 'logout'];
    const termsSelectedNotFullyRead = this.state.isRead
      ? ['scroll', 'logout', 'terms-text', button]
      : ['scroll', 'logout', button];

    if (this.state.isFullyRead) {
      ids = this.state.termsAgreed
        ? termsSelectableAgreed
        : termsSelectableDisagreed;
    } else {
      ids = termsSelectedNotFullyRead;
    }
    return ids;
  };

  keySelect = event => {
    const ids = this.getNavigationKeys();
    let i;
    const focusedElement = document.activeElement.id;
    const isModalOpen = this.props.headerStore.isModalOpen;
    if (
      this.state.index <= ids.length - 1 &&
      !this.state.modalIsOpen &&
      !isModalOpen
    ) {
      if (event.key === 'ArrowRight') {
        if (this.state.index === ids.length - 1) {
          if (focusedElement !== ids[this.state.index]) {
            const newID = ids.indexOf(focusedElement);
            i = newID + 1;
          } else {
            i = 0;
          }
          this.setState({ index: i });
          document.getElementById(ids[i]).focus();
        } else {
          if (focusedElement !== ids[this.state.index]) {
            const newID = ids.indexOf(focusedElement);
            if (ids.indexOf(focusedElement) === ids.length - 1) {
              i = 0;
            } else {
              i = newID;
            }
          } else {
            i = this.state.index;
          }
          i++;
          this.setState({ index: i });
          document.getElementById(ids[i]).focus();
        }
      }
    }

    if (event.key === 'ArrowLeft') {
      if (this.state.index === 0) {
        if (focusedElement !== ids[this.state.index]) {
          const newID = focusedElement
            ? ids.indexOf(focusedElement)
            : ids.length;
          i = newID - 1;
        } else {
          i = ids.length - 1;
        }
        this.setState({ index: ids.length - 1 });
        document.getElementById(ids[i]).focus();
      } else {
        if (focusedElement !== ids[this.state.index]) {
          const newID = focusedElement
            ? ids.indexOf(focusedElement)
            : ids.length;
          if (ids.indexOf(focusedElement) === 0) {
            i = ids.length;
          } else {
            i = newID;
          }
        } else {
          i = this.state.index;
        }
        i--;
        this.setState({ index: i });

        document.getElementById(ids[i]).focus();
      }
    }
  };

  setModalIndex = index => {
    this.setState({ modalIndex: index });
  };

  closeErrorModal = () => {
    this.props.history.push('/');
    SessionStorage.clearStorage();
  };

  modalNavigation = event => {
    const ids = ['button-primary-modal', 'close-modal'];

    const focusedElement = document.activeElement.id;
    const arrows = ['ArrowDown', 'ArrowUp'];
    if (this.state.modalIndex <= ids.length - 1 && this.state.modalIndex >= 0) {
      selectKey(
        event,
        this.state.modalIndex,
        ids,
        focusedElement,
        this.setModalIndex,
        arrows,
      );
    }
  };

  initSpeech = text => {
    let msg = new SpeechSynthesisUtterance();
    msg.addEventListener('end', e => {
      this.setState({ isFullyRead: true, isRead: false });
    });
    msg.text = text;
    return msg;
  };

  focusTerms = async () => {
    if (msg && window.speechSynthesis.paused) {
      window.speechSynthesis.resume();
      window.speechSynthesis.speak(msg);
    } else {
      let filteredTerms = this.state.terms
        .replace(/<\/?[^>]+(>|$)/g, '')
        .replace(/(&.*?;)/gi, ' ')
        .split(' ');
      for (let i = 0; i < filteredTerms.length; i++) {
        if (filteredTerms[i].includes('ACT')) {
          filteredTerms[i] = 'A C T';
        }
      }
      filteredTerms = filteredTerms.join(' ');
      if (msg) {
        window.speechSynthesis.resume();
        window.speechSynthesis.speak(msg);
      } else {
        await cancelSpeech();
        msg = this.initSpeech(filteredTerms);
        window.speechSynthesis.speak(msg);
      }
    }
    document.getElementById('terms-text').tabIndex = 8;
    this.setState({
      isRead: true,
    });
    document.getElementById('terms-text').setAttribute('aria-hidden', 'false');
    setTimeout(() => {
      document.getElementById('terms-text').focus();
    }, 100);
  };

  stopTerms = () => {
    window.speechSynthesis.pause();
    document.getElementById('terms-text').tabIndex = -1;
    this.setState({
      isRead: false,
    });

    setTimeout(() => {
      document.getElementById('terms-text').setAttribute('aria-hidden', 'true');
      if (document.getElementById('button-primary')) {
        document.getElementById('button-primary').focus();
      } else {
        document.getElementById('button-secondary').focus();
      }
    }, 200);
  };

  scrollFocus = event => {
    if (event.key === 'Enter') {
      this.scrollDown();
    }
  };

  render() {
    const agreeClass = classNames('agree-disagre-terms', {
      selected: this.state.termsAgreed,
    });

    const terms = this.state.terms;
    const override = css`
      display: block;
      margin: 0 auto;
    `;

    const filteredTerms = terms.replace(/<\/?[^>]+(>|$)/g, '').split(' ');
    for (let i = 0; i < filteredTerms.length; i++) {
      if (filteredTerms[i].includes('ACT')) {
        filteredTerms[i] = 'A C T';
      }
    }

    return (
      <main className="terms-and-conditions">
        {this.state.hasContent ? (
          <div
            className="terms-container"
            id="terms-container"
            style={{ maxHeight: this.state.size }}
          >
            <div
              className="terms-and-conditions-heading"
              tabIndex={0}
              autoFocus={true}
            >
              <h1>Examinee Statements</h1>
            </div>
            <div
              className="terms-text"
              id="terms-text"
              role="article"
              aria-label={filteredTerms}
            >
              <div
                aria-hidden="true"
                dangerouslySetInnerHTML={{
                  __html: terms,
                }}
              ></div>
            </div>
            <div
              className={agreeClass}
              onClick={this.agreeTerms}
              onKeyUp={this.onKeyPressAgree}
              tabIndex={-1}
              id="agree-terms"
              aria-label="I have read and AGREE to the Terms"
            >
              <div className="agree-disagre-title">
                <div className="radio-circle"></div>
                <p className="">I have read and AGREE to the Terms</p>
              </div>
            </div>
            <div className="buttons-container">
              {!this.state.isRead ? (
                <>
                  <ButtonPrimary
                    ariaHidden={this.state.ariaHidden}
                    aria-live="assertive"
                    aria-label="Read Aloud"
                    buttonText="Read Aloud"
                    hasArrow={false}
                    hasPlay="play"
                    onClick={this.focusTerms}
                    tabIndex={0}
                  />
                </>
              ) : (
                <ButtonSecondary
                  buttonText="Read Aloud"
                  hasArrow={false}
                  onClick={this.stopTerms}
                  tabIndex={0}
                  hasPlay="stop"
                  ariaHidden={this.state.ariaHidden}
                  aria-live="assertive"
                />
              )}
              {!this.state.scrollEnd && (
                <div
                  className="scroll"
                  id="scroll"
                  tabIndex="0"
                  aria-label="scroll down"
                  onKeyUp={this.scrollFocus}
                  role="application"
                >
                  <div
                    className="scroll-button"
                    onClick={this.scrollDown}
                    aria-hidden="true"
                  ></div>
                  <div className="scroll-text" aria-hidden="true">
                    SCROLL DOWN
                  </div>
                </div>
              )}
              {this.state.isFullyRead && (
                <ButtonPrimary
                  buttonText="Continue"
                  id="button1"
                  hasArrow={true}
                  isDisabled={!this.state.termsAgreed}
                  ariaLabel={
                    this.state.termsAgreed
                      ? `Continue Enabled`
                      : `Continue Disabled`
                  }
                  onClick={this.state.termsAgreed ? this.goNext : undefined}
                  tabIndex={0}
                />
              )}
            </div>
          </div>
        ) : (
          <div>
            <div
              className="spinner-container"
              role="alert"
              aria-label="Please wait, the page is getting loaded."
            >
              <FadeLoader
                css={override}
                size={'350px'}
                sizeUnit="px"
                color="#042E60"
                loading={this.state.loading}
                height={30}
                width={7}
                margin={20}
              />
            </div>
            <Modal
              isOpen={this.state.hasInvalidParams}
              className={'modal-content one-button'}
              ariaProps={{
                modal: true,
              }}
              child={
                <PopupOneButton
                  title="Error"
                  description="Something went wrong. Please try again"
                  buttonText="Go To Sign In"
                  padding="0 75px"
                  onClick={this.closeErrorModal}
                />
              }
            />
            <Modal
              isOpen={this.state.hasInvalidAuthParams}
              className={'modal-content one-button'}
              ariaProps={{
                modal: true,
              }}
              child={
                <PopupOneButton
                  title="Error"
                  description="You need to be logged in to access this page."
                  buttonText="Go To Sign In"
                  padding="0 75px 30px"
                  onClick={this.closeErrorModal}
                />
              }
            />
          </div>
        )}
      </main>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(TermsAndConditions);
